import React from 'react'
import {
  empCitationSearchResultRegion,
  origins,
  Region,
  UserClickPayload,
} from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import { userClick } from '@chegg-wt/core/state/instrumentation/actions'
import { connect } from 'react-redux'
import { JOURNAL } from '@chegg-wt/core/constants/journalTypes'
import {
  journalTypeSwitch,
  journalTypeSwitchText,
} from '@chegg-wt/core/utils/searchSources'
import { JournalType } from '@chegg-wt/core/types/core'
import {
  CREATE_MANUAL_CITATION,
  SEARCH_RESULT_JOURNAL_ERROR,
  SWITCH_JOURNAL_TYPE,
} from './utils/testids'
import * as Styled from './styled'

interface SearchResultJournalErrorProps {
  journalType: JournalType
  onManualCiteClick: (region: Region) => void
  onChangeJournalType: (journalType: JournalType) => void
  userClick: (payload: UserClickPayload) => void
}

const SearchResultJournalError: React.FunctionComponent<SearchResultJournalErrorProps> = ({
  journalType,
  onManualCiteClick,
  onChangeJournalType,
  userClick,
}) => {
  const handleJournalTypeChange = () => {
    const origin =
      journalType === JOURNAL
        ? origins.searchWithJstorAfterSearchResult
        : origins.searchWithCrossrefAfterSearchResult

    onChangeJournalType(journalTypeSwitch[journalType])
    userClick({ origin })
  }
  return (
    <Styled.ErrorContainer data-test={SEARCH_RESULT_JOURNAL_ERROR}>
      <Styled.LoadingDescription>
        <Styled.Heading>Journal search failed.</Styled.Heading>
        <Styled.NoResultBody>
          Try{' '}
          <Styled.LinkText
            data-test={CREATE_MANUAL_CITATION}
            onClick={() => {
              onManualCiteClick(empCitationSearchResultRegion)
            }}
          >
            creating a manual citation
          </Styled.LinkText>{' '}
          or{' '}
          <Styled.LinkText
            data-test={SWITCH_JOURNAL_TYPE}
            onClick={handleJournalTypeChange}
          >
            searching with {journalTypeSwitchText[journalType]}
          </Styled.LinkText>{' '}
          instead.
        </Styled.NoResultBody>
      </Styled.LoadingDescription>
    </Styled.ErrorContainer>
  )
}

const mapDispatchToProps = {
  userClick,
}
export default connect(null, mapDispatchToProps)(SearchResultJournalError)
